// ------------------------------------
// Selectors
// ------------------------------------
export const scaTokenTree = (state) => state.scaToken || {};
export const scaTokenIsLoading = (state) => scaTokenTree(state).isLoading;
export const scaTokenResp = (state) => scaTokenTree(state).tokenResp || {};
